import type SurfaceActionsOptionState from './schema/SurfaceActionsOptionState';
import { createStore } from 'owa-satcheljs';

const defaultExport: () => SurfaceActionsOptionState = createStore<SurfaceActionsOptionState>(
    'surfaceActionsOption',
    {
        readSurfaceActions: null,
        readSurfaceAddins: null,
        composeSurfaceActions: null,
        composeSurfaceAddins: null,
        hoverSurfaceActions: null,

        showSettingsHoverAction: undefined,
    }
);
export default defaultExport;
